export const TELL_THE_SERVER_EVERY = 2000;

export const HANDS_OFF_THE_KEYS_AFTER = 8000;

export const READ_THE_LINE_EVERY = 2000;

export function shouldTell(told: number | null, now: number): boolean {
  return told === null || now - told >= TELL_THE_SERVER_EVERY;
}

let lastKey: { conversation: string; at: number } | null = null;

export function keysTouched(conversation: string, now = Date.now()): void {
  lastKey = { conversation, at: now };
}

export function typedAgoIn(conversation: string, now = Date.now()): number | null {
  if (!lastKey || lastKey.conversation !== conversation) return null;
  return now - lastKey.at;
}
